'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.FONTS = void 0;
(function (FONTS) {
    FONTS["PRIMARY"] = "Labil Grotesk";
})(exports.FONTS || (exports.FONTS = {}));
exports.COLORS = void 0;
(function (COLORS) {
    COLORS["INDIGO_800"] = "#000000";
    COLORS["INDIGO_700"] = "#0B0028";
    COLORS["INDIGO_600"] = "#150050";
    COLORS["INDIGO_500"] = "#3C3353";
    COLORS["INDIGO_400"] = "#67677C";
    COLORS["INDIGO_300"] = "#9A9AA7";
    COLORS["INDIGO_200"] = "#CCCCD3";
    COLORS["INDIGO_100"] = "#EEEFF2";
    COLORS["INDIGO_50"] = "#F5F5F7";
    COLORS["GREY_800"] = "#373A41";
    COLORS["GREY_700"] = "#3E4249";
    COLORS["GREY_600"] = "#454951";
    COLORS["GREY_500"] = "#70747D";
    COLORS["GREY_400"] = "#9EA3AC";
    COLORS["GREY_300"] = "#B1B5BD";
    COLORS["GREY_200"] = "#C5C8CD";
    COLORS["GREY_100"] = "#D8DADE";
    COLORS["GREY_50"] = "#ECEDEE";
    COLORS["BLUE_800"] = "#32469C";
    COLORS["BLUE_700"] = "#384FAF";
    COLORS["BLUE_600"] = "#3E58C3";
    COLORS["BLUE_500"] = "#4967E5";
    COLORS["BLUE_400"] = "#6D85EA";
    COLORS["BLUE_300"] = "#92A4EF";
    COLORS["BLUE_200"] = "#B6C2F5";
    COLORS["BLUE_100"] = "#DBE1FA";
    COLORS["BLUE_50"] = "#EDF0FC";
    COLORS["LIGHT_BLUE_800"] = "#405AAD";
    COLORS["LIGHT_BLUE_700"] = "#4866C2";
    COLORS["LIGHT_BLUE_600"] = "#5071D8";
    COLORS["LIGHT_BLUE_500"] = "#5E85FE";
    COLORS["LIGHT_BLUE_400"] = "#7E9DFE";
    COLORS["LIGHT_BLUE_300"] = "#9EB6FE";
    COLORS["LIGHT_BLUE_200"] = "#BFCEFF";
    COLORS["LIGHT_BLUE_100"] = "#DFE7FF";
    COLORS["LIGHT_BLUE_50"] = "#EFF3FF";
    COLORS["CYAN_800"] = "#3E92AA";
    COLORS["CYAN_700"] = "#45A4BF";
    COLORS["CYAN_600"] = "#4DB6D4";
    COLORS["CYAN_500"] = "#56CAEC";
    COLORS["CYAN_400"] = "#78D5F0";
    COLORS["CYAN_300"] = "#9ADFF4";
    COLORS["CYAN_200"] = "#BBEAF7";
    COLORS["CYAN_100"] = "#DDF4FB";
    COLORS["CYAN_50"] = "#EEFAFD";
    COLORS["GREEN_800"] = "#237F5B";
    COLORS["GREEN_700"] = "#288F67";
    COLORS["GREEN_600"] = "#2C9F72";
    COLORS["GREEN_500"] = "#31B17F";
    COLORS["GREEN_400"] = "#5AC199";
    COLORS["GREEN_300"] = "#83D0B2";
    COLORS["GREEN_200"] = "#ADE0CC";
    COLORS["GREEN_100"] = "#D6EFE5";
    COLORS["GREEN_50"] = "#EAF7F2";
    COLORS["YELLOW_800"] = "#BE9E12";
    COLORS["YELLOW_700"] = "#D6B115";
    COLORS["YELLOW_600"] = "#EEC517";
    COLORS["YELLOW_500"] = "#FACF18";
    COLORS["YELLOW_400"] = "#FBD946";
    COLORS["YELLOW_300"] = "#FCE274";
    COLORS["YELLOW_200"] = "#FDECA3";
    COLORS["YELLOW_100"] = "#FEF5D1";
    COLORS["YELLOW_50"] = "#FFFAE8";
    COLORS["PEACH_800"] = "#C2915E";
    COLORS["PEACH_700"] = "#DAA369";
    COLORS["PEACH_600"] = "#F2B575";
    COLORS["PEACH_500"] = "#FFBF7B";
    COLORS["PEACH_400"] = "#FFCC95";
    COLORS["PEACH_300"] = "#FFD9B0";
    COLORS["PEACH_200"] = "#FFE5CA";
    COLORS["PEACH_100"] = "#FFF2E5";
    COLORS["PEACH_50"] = "#FFF9F2";
    COLORS["RED_800"] = "#A74339";
    COLORS["RED_700"] = "#BF4D41";
    COLORS["RED_600"] = "#D75649";
    COLORS["RED_500"] = "#EF6051";
    COLORS["RED_400"] = "#F28074";
    COLORS["RED_300"] = "#F5A097";
    COLORS["RED_200"] = "#F9BFB9";
    COLORS["RED_100"] = "#FCDFDC";
    COLORS["RED_50"] = "#FDEFEE";
    COLORS["PINK_800"] = "#AF6DAF";
    COLORS["PINK_700"] = "#C87CC8";
    COLORS["PINK_600"] = "#E18BE1";
    COLORS["PINK_500"] = "#FA9BFA";
    COLORS["PINK_400"] = "#FBAFFB";
    COLORS["PINK_300"] = "#FCC3FC";
    COLORS["PINK_200"] = "#FDD7FD";
    COLORS["PINK_100"] = "#FEEBFE";
    COLORS["PINK_50"] = "#FFF5FF";
    COLORS["WHITE_300"] = "#E6E0D6";
    COLORS["WHITE_200"] = "#FFF6E8";
    COLORS["WHITE_100"] = "#FFF8ED";
    COLORS["WHITE_50"] = "#FFFFFF";
    // legacy
    COLORS["BLACK_100"] = "#22222D";
    COLORS["WHITE"] = "#FFFFFF";
    COLORS["WARM_WHITE"] = "#FFF6E8";
    COLORS["LIGHT_RED"] = "#FFCCCC";
    COLORS["RED"] = "#E02915";
    COLORS["INDIGO"] = "#150050";
    COLORS["ROYAL_BLUE"] = "#1255C9";
    COLORS["OCEAN_BLUE"] = "#3656DC";
    COLORS["LIGHT_BLUE"] = "#D7DDF8";
    COLORS["DARK_GREEN"] = "#187E66";
    COLORS["ORANGE"] = "#BF5800";
    COLORS["YELLOW"] = "#FFE577";
    COLORS["PAPAYA_10"] = "#FFF8F2";
    COLORS["LILAC_50"] = "#D8D6FF";
    COLORS["MANGO_20"] = "#FFF9CC";
    COLORS["OCEAN_20"] = "#CDE4FF";
    COLORS["GREEN_20"] = "#CCFCCC";
    COLORS["ROSE_10"] = "#FFF4F4";
    COLORS["MANGO_300"] = "#FFD75D";
    COLORS["LILAC_500"] = "#7B77FF";
    COLORS["PAPAYA_500"] = "#E27815";
    COLORS["OCEAN_300"] = "#6DA5FF";
    COLORS["ROSE_500"] = "#F46565";
})(exports.COLORS || (exports.COLORS = {}));
var light_theme = {
    name: 'Light Theme',
    fonts: {
        primary: exports.FONTS.PRIMARY,
    },
    shadows: {
        0: 'none',
        1: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px 1px rgba(0, 0, 0, 0.08)',
        2: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 2px 3px rgba(0, 0, 0, 0.16)',
        3: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.16)',
        4: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 3px 6px rgba(0, 0, 0, 0.16)',
        5: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.16)',
        6: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 6px 10px rgba(0, 0, 0, 0.16)',
        7: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 12px 14px rgba(0, 0, 0, 0.16)',
        8: '0px 6px 18px rgba(0, 0, 0, 0.12), 0px 14px 20px rgba(0, 0, 0, 0.16)',
        9: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px 1px rgba(0, 0, 0, 0.08)',
    },
    colors: {
        brand: {
            primary: exports.COLORS.INDIGO_600,
            secondary: exports.COLORS.WHITE_200,
            background: exports.COLORS.WHITE_50,
        },
        button: {
            action: exports.COLORS.BLUE_500,
            hover: exports.COLORS.BLUE_600,
            danger: exports.COLORS.RED_700,
            disabled: exports.COLORS.INDIGO_100,
            link: exports.COLORS.WHITE_50,
            tertiary: exports.COLORS.INDIGO_600,
        },
        text: {
            primary: exports.COLORS.INDIGO_600,
            secondary: exports.COLORS.INDIGO_400,
            disabled: exports.COLORS.INDIGO_200,
            negative: exports.COLORS.RED_700,
            link: exports.COLORS.BLUE_500,
            link_hover: exports.COLORS.BLUE_700,
            light: exports.COLORS.WHITE_50,
        },
        icon: {
            primary: exports.COLORS.INDIGO_600,
            secondary: exports.COLORS.INDIGO_400,
            disabled: exports.COLORS.INDIGO_200,
            negative: exports.COLORS.RED_700,
            warning: exports.COLORS.PEACH_700,
            positive: exports.COLORS.GREEN_600,
            link: exports.COLORS.BLUE_500,
            link_hover: exports.COLORS.BLUE_700,
            light: exports.COLORS.WHITE_50,
        },
        background: {
            primary: exports.COLORS.WHITE_50,
            secondary: exports.COLORS.INDIGO_50,
            tertiary: exports.COLORS.INDIGO_100,
            stroke: exports.COLORS.INDIGO_100,
            dark: exports.COLORS.INDIGO_700,
            information: exports.COLORS.BLUE_100,
            warning: exports.COLORS.PEACH_200,
            negative: exports.COLORS.RED_200,
            positive: exports.COLORS.GREEN_200,
        },
        input: {
            enabled: exports.COLORS.INDIGO_400,
            hovered: exports.COLORS.INDIGO_600,
            disabled: exports.COLORS.INDIGO_200,
            negative: exports.COLORS.RED_700,
            focused: exports.COLORS.BLUE_500,
        },
    },
    typography: {
        headline_1: {
            font_size: '36px',
            line_height: '44px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        headline_2: {
            font_size: '32px',
            line_height: '40px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        headline_3: {
            font_size: '28px',
            line_height: '36px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        headline_4: {
            font_size: '24px',
            line_height: '32px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        headline_5: {
            font_size: '22px',
            line_height: '28px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        headline_6: {
            font_size: '18px',
            line_height: '24px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        title_1: {
            font_size: '18px',
            line_height: '26px',
            font_weight: 500,
            letter_spacing: '0.25px',
        },
        body_1: {
            font_size: '18px',
            line_height: '26px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        title_2: {
            font_size: '15px',
            line_height: '26px',
            font_weight: 500,
            letter_spacing: '0.25px',
        },
        body_2: {
            font_size: '15px',
            line_height: '26px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        button_text: {
            font_size: '16px',
            line_height: '16px',
            font_weight: 700,
            letter_spacing: '0.25px',
        },
        overline: {
            font_size: '12px',
            line_height: '18px',
            font_weight: 500,
            letter_spacing: '0.25px',
        },
        caption: {
            font_size: '12px',
            line_height: '18px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        display_1: {
            font_size: '64px',
            line_height: '76px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        display_2: {
            font_size: '56px',
            line_height: '64px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        display_3: {
            font_size: '44px',
            line_height: '52px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
        subheader_1: {
            font_size: '17px',
            line_height: '24px',
            font_weight: 600,
            letter_spacing: '0.25px',
        },
        subheader_2: {
            font_size: '14px',
            line_height: '20px',
            font_weight: 600,
            letter_spacing: '0.25px',
        },
    },
};

exports.light_theme = light_theme;
